import React, {Component} from 'react';
import {withStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {
    BottomNavigation, BottomNavigationAction,
    Box,
    Typography
} from "@material-ui/core";
import {inject, observer} from "mobx-react";

const style = theme => ({
    root:{
        width:'100%',
        border: '1px solid #c4c9de',
        borderRadius: 8,
        marginBottom: 40,
        padding:'30px 14px 25px',
    },
    textStyle:{
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.4rem',
        color: '#0d0d0d',
        fontWeight: 600,
    },
    explanationText:{
        fontSize: '1rem',
        fontWeight: 400,
        marginTop:12
    },
    titleImgBox:{
        width: 241,
        height: 181,
        overflow:'hidden',
        display:'flex',
        alignItems:'center'
    },
    buttonBox:{
        "& .MuiBottomNavigation-root":{
            justifyContent:'flex-start',
            flexWrap:'wrap',
            height:'inherit'
        },
        "& .MuiBottomNavigationAction-root.Mui-selected":{
            border:'1px solid #0097ff',
            background:'#fff',
            paddingTop:0
        },
        "& .MuiBottomNavigationAction-label.Mui-selected":{
            fontFamily: 'NanumSquareRoundOTF',
            color:'#0097ff',
            fontWeight: 600,
            fontSize: '1.4rem',
        },
        "& .MuiBottomNavigationAction-label":{
            fontFamily: 'NanumSquareRoundOTF',
            fontSize: '1.4rem',
            transaction:'none',
            transitionDelay:0,
        },
        "& .MuiBottomNavigation-root button:last-child":{
            marginRight:0
        }
    },
    toggleButtonStyle:{
        maxWidth:36,
        minWidth:36,
        height:36,
        padding:0,
        background:'rgba(163, 168, 175, 0.2)',
        color:'#a3a8af',
        marginRight:5,
        marginTop:5,
        borderRadius: 4,
        border:'1px solid rgba(163, 168, 175, 0.2)',
        "&:hover":{
            border:'1px solid #0097ff',
            background:'#fff',
            color:'#0097ff',
        }
    },
    actionText:{
        fontSize: '1rem',
        color: '#000',
        fontWeight: 500,
    }
});

@inject('statisticsStore')
@observer
class MobileSurveyRating extends Component {
    render() {
        const { classes, intl, statisticsStore, item } = this.props;
        const sortedOptions = item.options.map(o => ({...o})).sort((a, b) => a.number < b.number ? -1 : a.number > b.number ? 1 : 0);
        const itemAnswerList = statisticsStore.getUserSurveyItemAnswerList(item);
        const itemAnswer = itemAnswerList.length > 0 ? statisticsStore.getUserSurveyItemAnswerList(item)[0].optionId : 0;

        const labelDefaultWidth = (41 * ((sortedOptions.length)));
        const maxSelect = (11 - Math.ceil((window.innerWidth)/71) - sortedOptions[0].number);
        const labelWidth = item.options.length >= maxSelect ? '100%' : labelDefaultWidth;

        return (
            <div className={classes.root}>
                {item.title !== "" &&
                    <>
                        {item.required ?
                            <Typography className={classes.textStyle} style={{color: '#0d0d0d'}}>{item.title}<span style={{color: '#FF0000'}}>*</span></Typography>
                            :
                            <Typography className={classes.textStyle} style={{color: '#0d0d0d'}}>{item.title}</Typography>
                        }
                    </>
                }
                {item.contents !== "" &&
                    <>
                        <Typography className={clsx(classes.textStyle, classes.explanationText)} style={{color: '#0d0d0d'}}>{item.contents}</Typography>
                    </>
                }
                {item.images.length > 0 &&
                    item.images.map((images, i) => (
                        <Box key={item.surveyItemId + i} className={classes.titleImgBox} mb={2}>
                            <img src={images.image} alt="" style={{width: '100%'}}/>
                        </Box>
                    ))
                }

                <Box className={classes.buttonBox} mt={3}>
                    <BottomNavigation value={itemAnswer} showLabels>
                        {(sortedOptions.length > 0) &&
                            sortedOptions.map((option) => (
                                <BottomNavigationAction  key={option.surveyItemOptionId} value={option.surveyItemOptionId} label={option.number} className={clsx(classes.textStyle, classes.toggleButtonStyle)}/>
                            ))
                        }
                    </BottomNavigation>
                    {(sortedOptions.length > 0) &&
                        <Box display='flex' justifyContent='space-between' alignItems='center' style={{marginTop:20, minWidth: '84px', width: labelWidth}}>
                            <Typography className={clsx(classes.textStyle, classes.actionText)}>{sortedOptions[0].contents !== "" ? sortedOptions[0].contents : intl.formatMessage({id: "highly_dissatisfied"})}</Typography>
                            <Typography className={clsx(classes.textStyle, classes.actionText)}>{sortedOptions[0].contents !== "" ? sortedOptions[0].contents : intl.formatMessage({id: "highly_satisfied"})}</Typography>
                        </Box>
                    }
                </Box>
            </div>
        );
    }
}

export default withStyles(style)(MobileSurveyRating);